import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMessage, setSubTitle } from "../stores/AppReducer";
import { IUser, MessageType } from "../interfaces/App";
import { updUser } from "../services/apiService";
import { useNavigate, useParams } from "react-router-dom";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";
import CustomInputValidity from "./CustomInputValidity";
import UserNotification from "./UserNotification";
import Passkey from "./Passkey";

function Profile() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const whatParam = useParams();
    const times = useRef(0);
    const [placeholder, setPlaceholder] = useState("pass");
    const [what, setWhat] = useState(null);
    const [changed, setChanged] = useState(false);
    const app = useSelector((appState: IApplicationState) => appState.app);
    const initialUser: IUser = {
        id: app.user.id,
        name: app.user.name,
        email: app.user.email ? app.user.email : "",
        phone: app.user.phone ? app.user.phone : "",
        passwd: "",
        oldPass: "",
        confirm: "",
        readonly: false,
        hasToken: false,
        newsInfo: 0
    };
    const [localUser, setUser] = useState(initialUser);

    const findCode = (whatCode: string) => {
        switch (whatCode) {
            case "smscode": return "SMS Code";
            case "emailcode": return "Email Code";
            case "pass": return "altes Passwort";
            default: return null;
        }
    };

    useEffect(() => {
        if (times.current++ === 0) {
            dispatch(setSubTitle("Profile"));
            if (whatParam) {
                const tmp = (whatParam as {what: string}).what?.replace(/:/, "");
                setWhat(tmp);
                setPlaceholder(findCode(tmp));
            }
        }
    }, []);
    useEffect(() => {
        if (app.user.oldPass && app.user.id) {
            setUser({...initialUser, email: app.user.email, name: app.user.name, phone: app.user.phone, oldPass: app.user.oldPass, id: app.user.id});
        }
    }, [app.user]);

    const handleSubmit = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        if ((localUser.passwd.length > 0 || what === "code") 
            && localUser.confirm.length > 0
            && localUser.oldPass.length > 0
        ) {
            if (localUser.passwd === localUser.confirm) {
                dispatch(updUser({...localUser, adminId: app.user.id})).then((res: any) => {
                    if (res.type === "put/User/fulfilled") {
                        navigate("/login");
                    }
                });     
            } else {
                dispatch(setMessage({msg: "Passwörter sind nicht gleich", type: MessageType.error}));
            }
        }
        if (what === "all") {
            dispatch(updUser({...localUser, adminId: app.user.id})).then(() => setChanged(false));
        } 
    };
    const renderCompleteProfile = () => {
        return (
            <div className="loginBox">
                <CustomInputValidity
                    id={"identifier"}
                    value={what === "smscode" ? localUser.phone : localUser.email}
                    label={what === "smscode" ? "Mobilnummer" : "E-Mail"}
                    className={"custom_input"}
                    readOnly={true}
                    tabIndex={-1}
                />
                {placeholder && <CustomInputValidity
                    id={"oldPass"}
                    value={localUser.oldPass}
                    label={placeholder}
                    setState={(_name, oldPass) => setUser({...localUser, oldPass})}
                    autoComplete="current-password"
                    className={"custom_input"}
                />}
                <CustomInputValidity
                    id={"passwd"}
                    value={localUser.passwd} 
                    label={"neues Passwort"}
                    setState={(_name, passwd) => setUser({...localUser, passwd})}
                    additional={"eye"}
                    autoComplete="new-password"
                    className={"custom_input"}
                />
                <CustomInputValidity
                    id={"passwd"}
                    value={localUser.confirm} 
                    label={"wiederhole Passwort"}
                    setState={(_name, confirm) => setUser({...localUser, confirm})}
                    additional={"eye"}
                    autoComplete="confirm-password"
                    className={"custom_input"}
                />
                <input type="submit" className="animButton" value="Ok" />
                <div className="clear"/>
            </div>
        );
    };
    const renderProfile = () => {
        return (
            <div>
                <div className="dialog_box">
                    <CustomInputValidity
                        id={"name"}
                        value={localUser.name} 
                        label={"Dein Name hier"}
                        setState={(_name, name) => {setChanged(true); setUser({...localUser, name}); }}
                        className={"custom_input"}
                    />
                    <div/>
                    <CustomInputValidity
                        id={"email"}
                        value={localUser.email} 
                        label={"E-Mail-Adresse"}
                        setState={(_name, email) => {setChanged(true); setUser({...localUser, email}); }}
                        className={"custom_input"}
                    />
                    <div/>
                    <CustomInputValidity
                        id={"phone"}
                        value={localUser.phone} 
                        label={"Mobile Telefonnummer"}
                        setState={(_name, phone) => {setChanged(true); setUser({...localUser, phone}); }}
                        className={"custom_input"}
                    />
                    <button className="animButton" disabled={!changed}>Speichern</button>
                </div>
                
            </div>
        );
    };
    return (
        <div className="page">
            <form onSubmit={(ev: any) => handleSubmit(ev)} >
                {what === "all" ? renderProfile() : renderCompleteProfile()}
            </form>
            {(app.loggedIn && what === "all") && <Passkey />}
            {(app.loggedIn && what === "all") && <UserNotification />}
            <div className="back_btn">
                <a href="/#/login" >Zurück</a>
            </div>
            <div className="clear"/>
        </div>
    );
}
export default Profile;
